import { CategoryTypeEnum } from '@repo/common/enums';
import { VpIconName } from '@vtmn-play/react';

export const categoryIcons: Record<CategoryTypeEnum, VpIconName> = {
  REPAIR: 'circularity-maintain-repair',
  BUY_BACK: 'circularity-buy-back',
  CUSTOMIZATION: 'customize',
  TEST_E_BIKE: 'riding',
  SPORT_ACTIVITY: 'run',
  UNKNOWN: 'question',
};
